export const formatNumberValue = (value, min, max) => {
  value = parseInt(value, 10);
  return !isNaN(value) ? getValueRange(value, min, max) : min;
};

export const getValueRange = (value, min, max) => (value < min ? min : value > max ? max : value);

export const getFormattedColor = (color, fallback) => {
  const regex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

  if (color.length === 4 && color.charAt(0) === '#') {
    const colorString = `${color[0]}${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${
      color[3]
    }`;
    return regex.test(colorString) ? colorString : fallback;
  } else if (color.length < 7 || !regex.test(color)) {
    return fallback;
  } else {
    return color.slice(0, 7);
  }
};

export const getFormStyles = config => {
  const { bgColor, textColor, enabledMaxWidth, maxWidth } = config.form;
  const { family } = config.font;

  return {
    fontFamily: family,
    backgroundColor: bgColor,
    color: textColor,
    maxWidth: enabledMaxWidth ? `${maxWidth}px` : 'none',
  };
};

export const getLabelStyles = config => {
  const { size } = config.font;

  return {
    fontSize: `${size}px`,
  };
};

export const getFieldStyles = config => {
  const { family, size } = config.font;
  const { bgColor, textColor, height } = config.field;

  return {
    fontFamily: family,
    fontSize: `${size}px`,
    backgroundColor: bgColor,
    color: textColor,
    height: `${height}px`,
  };
};

export const getAdditionalFieldStyles = config => {
  const { additionalTextColor } = config.form;

  return {
    color: additionalTextColor,
  };
};

export const getFormGroupStyles = config => {
  const { maxWidth, enabledMaxWidth } = config.field;
  return { maxWidth: enabledMaxWidth ? `${maxWidth}px` : 'none' };
};

export const getButtonStyles = config => {
  const { family } = config.font;
  const {
    bgColor,
    borderRadius,
    enabledMaxWidth,
    maxWidth,
    height,
    textColor,
    textSize,
  } = config.button;

  return {
    fontFamily: family,
    backgroundColor: bgColor,
    borderRadius: `${borderRadius}px`,
    maxWidth: enabledMaxWidth ? `${maxWidth}px` : 'none',
    height: `${height}px`,
    color: textColor,
    fontSize: `${textSize}px`,
  };
};